import { action } from 'mobx'
import { pick } from 'lodash'
import sessionxtd from 'core/sessionxtd'
import Conversation from '../models/Conversation'
import store from '../store'
import storage from 'core/storage'
import { isDeleted } from 'core/utils'
import { ccpProvider } from 'core/CcpProvider'

export default class Chat {
  @action
  async initWebSocket() {
    store.socket = await ccpProvider?.initWebsocket()
    store.socket?.connect()
  }

  @action
  findByUserConversationUid(conversationUid) {
    return store.conversations.find(c => c.conversationUid === conversationUid)
  }

  @action
  findConversationByUsername(username) {
    return store.conversations.find(c => c.otherUserProfile?.username === username)
  }

  @action
  addConversation(data) {
    let conv = this.findByUserConversationUid(data.conversationUid)
    // if it exists and not deleted - update it
    if (conv && !isDeleted(conv)) {
      // Preserve existing messages to avoid losing optimistic updates
      const existingMessages = conv.messages
      Object.assign(conv, data)
      conv.messages = existingMessages
      return conv
    }
    // if deletion was after this create event (0 for initial) - ignore
    if (isDeleted(conv) && conv.deletedAt > (data.restoredAt || 0)) {
      return
    }
    // if we're restoring the conversation - remove the old one and create new one
    if (isDeleted(conv)) {
      store.conversations.remove(conv)
    }
    conv = new Conversation(data)
    store.conversations.push(conv)
    this.updateConversationCache(conv)

    return conv
  }

  @action
  deleteConversation(data) {
    const conv = this.findByUserConversationUid(data.conversationUid)
    if (conv && conv.restoredAt < data.deletedAt) {
      Object.assign(conv, data)
    }
    this.updateConversationCache(conv)
  }

  /**
   * Updates/creates cache entry for a conversation
   * @param {object} conversation : conversation like object { conversationUid } is mandatory
   */
  @action
  updateConversationCache(conv) {
    const cacheKey = ccpProvider.api.generateCacheKey(ccpProvider.api.widget.endpoints.WIDGET_GET_CONVERSATIONS, { userUid: CONFIG.userUid })
    const { item, expiration } = sessionxtd.getItem(cacheKey, true) || {}
    if (item) {
      const index = item.conversations.findIndex(c => c.conversationUid === conv.conversationUid)
      if (index >= 0) { // existing conv
        item.conversations[index] = { ...item.conversations[index], ...conv }
      } else { // new conv
        item.conversations.push(conv)
      }
      sessionxtd.setItem(cacheKey, { ...item, conversations: item.conversations }, 0, expiration)
    }
  }

  @action
  setUserConversation(conversationUid) {
    if (store.conversationUid !== conversationUid) {
      storage.set(`conversation-${CONFIG.userUid}`, conversationUid)
      store.conversationUid = conversationUid
    }
  }

  @action
  readConversation(conversation) {
    if (conversation?.unreadByMeCount) {
      const index = store.conversations.findIndex(c => c.conversationUid === conversation.conversationUid)
      store.conversations[index].unreadByMeCount = 0
      store.conversations[index].meReadAt = parseInt(Date.now() / 1000)
      ccpProvider.api.ccp.readConversation({ conversationUid: conversation.conversationUid, senderUid: conversation.meUid })
      this.updateConversationCache(pick(conversation, ['conversationUid', 'unreadByMeCount', 'conversationUid', 'meReadAt']))
    }
  }

  @action
  setActionProfileSearchTerm(term) {
    store.actionProfileSearchTerm = term
  }

  @action
  setChatLocked() {
    store.conversation.featuredApUnlock.isChatLocked = true;
  }
}
